import { SubscriptionRoutes } from "..";
import styled from "@emotion/styled";
import { format } from "date-fns";
import { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { ActionLink } from "components/links/ActionLink";
import { StyledLink } from "components/links/StyledLink";
import { Td } from "components/table";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { formatPrice } from "helpers/subscription";
import { IInvoice, InvoiceStatus } from "interfaces/entities/invoice";
import { IStoreState } from "interfaces/storeState";
import { InvoicesViewActions } from "store/views/invoices/actions";
import { getIsInvoiceDownloading } from "store/views/invoices/selectors";
import { capitalizeFirstLetter } from "utils/string";

interface IDispatchProps {
  downloadInvoice(id: number): void;
}

interface IStateProps {
  isInvoiceDownloading: boolean;
}

interface IOwnProps {
  invoice: IInvoice;
}

interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

interface IState {
  linkClicked: boolean;
}

interface IStyledTr {
  isDeclined: boolean;
}

const StyledTr = styled.tr<IStyledTr>`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isDeclined ? props.theme.errorColor : props.theme.primaryColor)
  };
  border-bottom: 1px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.borderColor
    };
`;

const StyledLinkWrapper = styled.div`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  margin-left: 5px;
  display: inline-block;
`;

class SubscriptionInvoicesTableRow extends Component<IProps, IState> {
  state = {
    linkClicked: false,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidUpdate(prevProps: IProps) {
    if (prevProps.isInvoiceDownloading === true && this.props.isInvoiceDownloading === false) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        linkClicked: false,
      });
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleInvoiceDownload = (id: number) => () => {
    trackEngagement("Invoices list: Invoice downloaded", EventPlace.Invoices);
    this.setState({
      linkClicked: true,
    });
    this.props.downloadInvoice(id);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  preparedStatus() {
    const {
      invoice: { status },
    } = this.props;
    switch (status) {
      case InvoiceStatus.Paid:
        return "Paid";
      case InvoiceStatus.PastDue:
        return "Declined";
      default:
        return capitalizeFirstLetter(status);
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      invoice: { id, createdAt, totalCents, status, items },
      isInvoiceDownloading,
    } = this.props;
    const { linkClicked } = this.state;

    const payment = totalCents / 100;
    const isDeclined = status === InvoiceStatus.PastDue;
    const isDownloading = linkClicked && isInvoiceDownloading;

    return (
      <StyledTr isDeclined={isDeclined}>
        <Td>{format(createdAt, "DD MMM, YYYY")}</Td>
        <Td>
          {items.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={i}>{item.description}</div>
          ))}
        </Td>
        <Td>{formatPrice(payment)}</Td>
        <Td>
          {this.preparedStatus()}
          {isDeclined && (
            <StyledLinkWrapper>
              (
              <StyledLink to={`${SubscriptionRoutes.AccountDetails}#billing-details`}>
                update billing details
              </StyledLink>
              )
            </StyledLinkWrapper>
          )}
        </Td>
        <Td>
          {isDownloading && <>Downloading…</>}
          {!isDownloading && (
            <ActionLink data-testid={`${id}-invoice-download-button`} onClick={this.handleInvoiceDownload(id)}>
              Download
            </ActionLink>
          )}
        </Td>
      </StyledTr>
    );
  }
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  isInvoiceDownloading: getIsInvoiceDownloading(state),
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  // @ts-expect-error TS(2345)
  downloadInvoice: (id: number) => dispatch(InvoicesViewActions.downloadInvoice(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionInvoicesTableRow);
